import React from "react";
import Icon from "@mdi/react";
import {
  mdiTwitter,
  mdiInstagram,
  mdiMedium,
  mdiLinkedin,
  mdiDribbble,
  mdiYoutube,
  mdiVimeo,
  mdiCalendarBlank
} from "@mdi/js";

const icons = {
  twitter: mdiTwitter,
  instagram: mdiInstagram,
  medium: mdiMedium,
  linkedin: mdiLinkedin,
  dribbble: mdiDribbble,
  youtube: mdiYoutube,
  vimeo: mdiVimeo,
  calendar: mdiCalendarBlank
};

export default ({
  placeholder,
  label,
  required,
  max,
  notice,
  value,
  setValue,
  icon,
  error,
  type = "text",
  suffix,
  regex,
  ...props
}) => {
  const onChange = event => {
    const { value: val } = event.target;
    if (max && val.length > max) setValue(val.slice(0, max));
    else if (regex && !regex.test(val)) return;
    else setValue(val);
  };

  return (
    <label className={`input ${error ? "-error" : ""}`}>
      <div className="input_label">
        <div>
          {label}
          {required && <span className="input_required">*</span>}
        </div>
        {max && (
          <div className="input_count">
            {value ? value.length : 0} / {max}
          </div>
        )}
      </div>

      <input
        className={`input_input ${icon ? "-icon" : ""}`}
        value={value || ""}
        placeholder={placeholder}
        onChange={onChange}
        type={type}
        {...props}
      />

      {icon && (
        <div className="input_icon">
          <Icon path={icons[icon]} size="22px" color="#949494" />
        </div>
      )}

      {suffix && <div className="input_suffix">{suffix}</div>}

      {notice && <div className="input_notice">{notice}</div>}
    </label>
  );
};
